import { Button, Checkbox, DatePicker, Form, Select, TimePicker } from 'antd';
import { postApi, putApi } from 'apis';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import { FC, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';

import utc from 'dayjs/plugin/utc';

dayjs.extend(duration);
dayjs.extend(utc); // Extend UTC support
dayjs.extend(timezone);
const AddSubscriptionBody: FC<SideDrawerBodyProps> = (props) => {
	// Inits
	const { closeDrawerByAnimation, editSelectedSubscription, fetchSubscription, selectedRowData } = props;
	const [form] = Form.useForm();
	// State Management
	const [selectedMode, setSelectedMode] = useState<string | null>();
	// const [selectedRole, setSelectedRole] = useState(
	// 	editSelectedSubscription ? editSelectedSubscription?.roleId : null
	// );
	// const [isSelected, setIsSelected] = useState<boolean>();
	// const [showError, setShowError] = useState<boolean>();
	// const [loading, setLoading] = useState<boolean>();
	const [isLoading, setIsLoading] = useState(false);
	console.log(isLoading);

	const editData = {
		...editSelectedSubscription,
	};
	const firstSubscription = editData?.subscriptions?.[0];
	
	const handleSubmit = async (values: any) => {
		const { mode, recurring } = values
		try {
			setIsLoading(true);

			const formattedDueTimestamp = values.due_timestamp
				? dayjs(values.due_timestamp).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
				: null;

			const formattedRemainingTime = values.remaining_time
				? dayjs(values.remaining_time).format('HH:mm:ss')
				: '00:00:00';

			const payload = {
				mode, 
				recurring,
				deviceId: firstSubscription ? firstSubscription?.deviceId : selectedRowData?.id, 
				additionalTime: formattedRemainingTime, // Keep HH:mm:ss format
				dueTimestamp: formattedDueTimestamp, // Convert to ISO 8601 format
			};
			let response;
			if (firstSubscription && firstSubscription !== undefined) {
				// **EDIT FLOW**
				response = await putApi(`/subscriptions/${payload?.deviceId}`, payload);
			} else {
				// // **ADD FLOW**
				response = await postApi('/subscriptions/create', payload);
			}

			if (response.status === 200) {
				toastText(`Subscription ${editData ? 'updated' : 'added'} successfully`, 'success');
				fetchSubscription?.();
			}
		} catch (error: any) {
			toastText(error.message, 'error');
		} finally {
			setIsLoading(false);
			form.resetFields()
			closeDrawerByAnimation();
		}
	};

	useEffect(() => {
		if (editData?.subscriptions?.[0]) {
			const sub = editData.subscriptions[0];

			// Set fields manually (especially Date/Time)
			form.setFieldsValue({
				...sub,
				due_timestamp: sub.dueTimestamp ? dayjs(sub.dueTimestamp) : null,
				remaining_time: sub.additionalTime ? dayjs(sub.additionalTime, 'HH:mm:ss') : null,
			});

			// Set selected mode for conditional rendering
			setSelectedMode(sub.mode);
		}
	}, [editData?.subscriptions, form]);


	// JSX
	return (
		<div className={styles['side-drawer-body']}>
			<Form
				form={form}
				name="basic"
				autoComplete="off"
				layout="vertical"
				labelAlign="left"
				className={styles['side-drawer-form']}
				onFinish={handleSubmit}
				onValuesChange={(changedValues) => {
					if (changedValues.mode) {
						setSelectedMode(changedValues.mode);
					}
				}}
			>
				<div className={styles['side-drawer-form__inputs']}>
					<Form.Item name="mode" label="Mode" rules={[{ required: true, message: 'Mode is required' }]}>
						<Select placeholder="Select Mode">
							<Select.Option value="Monthly">Monthly</Select.Option>
							<Select.Option value="Yearly">Yearly</Select.Option>
							<Select.Option value="Timer">Timer</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item name="recurring" valuePropName="checked">
						<Checkbox>Recurring</Checkbox>
					</Form.Item>

					{/* Show TimePicker only for "Timer" mode */}
					{selectedMode === 'Timer' && (
						<Form.Item name="remaining_time" label="Remaining Time (HH:mm:ss)" rules={[{ required: true }]}>
							<TimePicker defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')} format="HH:mm:ss" />
						</Form.Item>
					)}

					{/* Show DatePicker only for "Monthly" or "Yearly" mode */}
					{(selectedMode === 'Monthly' || selectedMode === 'Yearly') && (
						<Form.Item name="due_timestamp" label="Due Timestamp" rules={[{ required: true }]}>
							<DatePicker showTime />
						</Form.Item>
					)}
				</div>
				
				<div className={styles['side-drawer-form__buttons']}>
					<Button
						htmlType="submit"
						className={styles['side-drawer-form__buttons--edit']}
						// loading={loading} //loading
					>
						{editSelectedSubscription ? 'Edit' : 'Save'}
					</Button>

					<Button
						htmlType="reset"
						className={styles['side-drawer-form__buttons--cancel']}
						// disabled={loading}
						onClick={closeDrawerByAnimation}
					>
						Cancel
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default AddSubscriptionBody;
